import Form from 'react-bootstrap/Form';
import { ErrorMessage, useFormikContext } from 'formik';

function RegulationSection({
  values,
  handleChange,
  handleBlur,
  errors,
  disabled,
}) {
  const { setFieldValue } = useFormikContext();

  return (
    <div className='d-flex flex-column gap-3'>
      <h5 id='section-implementation' className='mt-4'>
        Genomförande & bestämmelser
      </h5>
      <Form.Group controlId='Regulation.CompetitionForms'>
        <Form.Label>Tävlingsform</Form.Label>
        <div className='d-flex gap-4'>
          <Form.Check
            required
            name='Regulation.CompetitionForms'
            type='radio'
            label='Traditionell'
            feedback='Du måste välja en tävlingsform'
            id='radio-traditional'
            feedbackType='invalid'
            value='traditional'
            defaultChecked={
              values.Regulation?.CompetitionForms === 'traditional'
            }
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={disabled}
          />
          <Form.Check
            required
            feedback='Du måste välja en tävlingsform'
            feedbackType='invalid'
            name='Regulation.CompetitionForms'
            type='radio'
            id='radio-sprint'
            label='Sprint'
            value='sprint'
            defaultChecked={values.Regulation?.CompetitionForms === 'sprint'}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={disabled}
          />
        </div>
      </Form.Group>

      <Form.Group controlId='Regulation.RaceClasses' className='d-flex flex-column align-items-start'>
        <Form.Label>Klasser</Form.Label>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem 3rem' }}>
          <Form.Check
            name='Regulation.RaceClasses'
            label='Junior'
            id='check-junior'
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={!!errors.Regulation?.RaceClasses}
            value='junior'
            checked={values.Regulation?.RaceClasses?.includes('junior')}
            disabled={disabled}
          />
          <Form.Check
            name='Regulation.RaceClasses'
            label='Senior'
            id='check-senior'
            onChange={(e) => {
              const toRemove = e.target.checked ? ['fwd', 'rwd'] : ['senior'];
              const filtered = values.Regulation?.RaceClasses
                  ?.filter(rc => !toRemove.includes(rc)) ?? [];
              if (e.target.checked) filtered.push('senior');
              setFieldValue('Regulation.RaceClasses', filtered);
            }}
            onBlur={handleBlur}
            isInvalid={!!errors.Regulation?.RaceClasses}
            checked={values.Regulation?.RaceClasses?.includes('senior')}
            disabled={disabled || values.Regulation?.RaceClasses?.includes('fwd')}
          />
          <Form.Check
            name='Regulation.RaceClasses'
            label='Dam'
            id='check-women'
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={!!errors.Regulation?.RaceClasses}
            value='women'
            checked={values.Regulation?.RaceClasses?.includes('women')}
            disabled={disabled}
          />
          <Form.Check
            name='Regulation.RaceClasses'
            label='Veteran'
            id='check-veteran'
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={!!errors.Regulation?.RaceClasses}
            value='veteran'
            checked={values.Regulation?.RaceClasses?.includes('veteran')}
            disabled={disabled}
          />
          <Form.Check
            name='Regulation.RaceClasses'
            label='FWD/RWD'
            id='check-fwd-rwd'
            onChange={(e) => {
              const toRemove = e.target.checked ? ['senior'] : ['fwd', 'rwd'];
              const filtered = values.Regulation?.RaceClasses
                  ?.filter(rc => !toRemove.includes(rc)) ?? [];
              if (e.target.checked) filtered.push('fwd', 'rwd');
              setFieldValue('Regulation.RaceClasses', filtered);
            }}
            onBlur={handleBlur}
            isInvalid={!!errors.Regulation?.RaceClasses}
            checked={values.Regulation?.RaceClasses?.includes('fwd')}
            disabled={disabled || values.Regulation?.RaceClasses?.includes('senior')}
          />
        </div>

        <ErrorMessage name='Regulation.RaceClasses'>
          {(msg) => (
            <span style={{ color: '#dc3545', fontSize: '14px' }}>
              {msg}
            </span>
          )}
        </ErrorMessage>
      </Form.Group>

      <Form.Group controlId='Regulation.MaxNbrOfParticipants'>
        <Form.Label>Maxantal för tävlingen (frivilligt)</Form.Label>
        <Form.Control
          className='p-2'
          placeholder='Ange max antal tävlande'
          value={values.Regulation?.MaxNbrOfParticipants}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
        ></Form.Control>
      </Form.Group>

      <Form.Group controlId='Regulation.ResultAssigned'>
        <Form.Label>Resultatlistan anslås</Form.Label>
        <Form.Control
          className='p-2'
          placeholder='Ange hur resultatlistan anslås'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.ResultAssigned}
          value={values.Regulation?.ResultAssigned}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.ResultAssigned}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.TimeTable'>
        <Form.Label>Tidsplan</Form.Label>
        <Form.Control
          as='textarea'
          placeholder='Ange tidsplan'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.TimeTable}
          value={values.Regulation?.TimeTable}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.TimeTable}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.CompetitionImplementation'>
        <Form.Label>Tävlingens genomförande</Form.Label>
        <Form.Control
          as='textarea'
          placeholder='Ange tävlingens genomförande'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.CompetitionImplementation}
          value={values.Regulation?.CompetitionImplementation}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.CompetitionImplementation}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.StartOrder'>
        <Form.Label>Startordning</Form.Label>
        <Form.Control
          required
          placeholder='Ange startordning'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.StartOrder}
          value={values.Regulation?.StartOrder}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.StartOrder}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.StartLineup'>
        <Form.Label>Startuppställning</Form.Label>
        <Form.Control
          placeholder='Ange startuppställning'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.StartLineup}
          value={values.Regulation?.StartLineup}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.StartLineup}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.EnvironmentRegulation'>
        <Form.Label>Miljö</Form.Label>
        <Form.Control
          required
          placeholder='Ange miljö'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.EnvironmentRegulation}
          value={values.Regulation?.EnvironmentRegulation}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.EnvironmentRegulation}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.FalseStartAction'>
        <Form.Label>Åtgärd vid tjuvstart</Form.Label>
        <Form.Control
          placeholder='Ange åtgärd vid tjuvstart'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.FalseStartAction}
          value={values.Regulation?.FalseStartAction}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.FalseStartAction}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.TireLimitation'>
        <Form.Label>Däckbeskrivning</Form.Label>
        <Form.Control
          placeholder='Ange däckbeskrivning'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.TireLimitation}
          value={values.Regulation?.TireLimitation}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.TireLimitation}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.Fee'>
        <Form.Label>Avgifter</Form.Label>
        <Form.Control
          placeholder='Ange avgifter'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.Fee}
          value={values.Regulation?.Fee}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.Fee}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.Commercials'>
        <Form.Label>Reklam</Form.Label>
        <Form.Control
          placeholder='Ange reklam'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.Commercials}
          value={values.Regulation?.Commercials}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.Regulation?.Commercials}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='Regulation.Prizes'>
        <Form.Label>Priser (frivilligt)</Form.Label>
        <Form.Control
          placeholder='Ange priser'
          className='p-2'
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors.Regulation?.Prizes}
          value={values.Regulation?.Prizes}
          disabled={disabled}
        ></Form.Control>
      </Form.Group>
    </div>
  );
}

export default RegulationSection;
